import { ReactNode } from "react";
import { Box, useTheme } from "@mui/material";

interface RiskTrajectoryProps {
    from: ReactNode;
    to?: ReactNode;
}

// Renders a risk transition as "from → to" with a muted arrow. Shared by the assessments overview (current →
// target/eliminated) and the area history ledger (rating deltas, accept holding flat, avoid → eliminated,
// mitigation → expected residual) so the arrow and layout stay identical across both. When `to` is omitted only
// the single "from" pill is shown.
function RiskTrajectory({ from, to }: RiskTrajectoryProps) {
    const theme = useTheme();
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: theme.spacing(1), flexWrap: "wrap" }}>
            {from}
            {to != null && (
                <>
                    <Box component="span" sx={{ color: theme.palette.text.secondary }}>
                        →
                    </Box>
                    {to}
                </>
            )}
        </Box>
    );
}

export default RiskTrajectory;
